import { useSelector } from 'react-redux'
import { preview } from '@/components/form/preview'
import { selectGpsTrackingProvider } from '@/features/domain/user'
import { DriverViewHeader } from './components/DriverViewHeader'
import { useTexts } from './hooks/useTexts'
import { DriverApp } from './components/DriverApp'

type DriverViewProps = {
  driver: uui.domain.client.rm.ExtendedDriver
}

export function DriverView(props: DriverViewProps) {
  const {
    driver: { driver },
  } = props
  const { labels } = useTexts()

  const trackingProvider = useSelector(selectGpsTrackingProvider)

  return (
    <preview.Root applyPendingFitMapOnMount={false} header={<DriverViewHeader {...props} />}>
      <preview.Field label={labels.name}>{driver.name}</preview.Field>
      <preview.Field label={labels.email}>{driver.deployment.email}</preview.Field>
      <preview.Divider />
      <DriverApp driver={props.driver} trackingProvider={trackingProvider} />
    </preview.Root>
  )
}
